import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Info from './pages/Info';
import Orders from './pages/Orders';
import SignalsFirmware from './pages/SignalsFirmware';
import FredFirmware from './pages/FredFirmware';
import NotFound from './pages/NotFound';
import './styles/App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/info" element={<Info />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/signals-firmware" element={<SignalsFirmware />} />
        <Route path="/fred-firmware" element={<FredFirmware />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
